const CARD_ITEMS = [
  {
    id: 1,
    title: '国产喜剧电影迎来黄金时代',
    desc: '从开心麻花到贾玲，国产喜剧不断创新突破，票房与口碑齐飞，好作品层出不穷。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20cinematic%20scene%20with%20warm%20lighting%2C%20bright%20and%20vibrant%20colors%2C%20film%20poster%20style%2C%20joyful%20atmosphere%2C%20golden%20and%20coral%20tones&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑剧天花板：这5部不容错过',
    desc: '高分悬疑剧推荐，烧脑剧情与精湛演技的完美结合，每部都值得反复品味。',
    tag: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20scene%20with%20moody%20warm%20lighting%2C%20dark%20amber%20and%20crimson%20tones%2C%20film%20poster%20style%2C%20suspenseful%20atmosphere%2C%20dramatic%20shadows&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '4K修复让经典电影焕发新生',
    desc: '高清修复技术让老电影重获新生，那些年的胶片质感在4K画质下展现出别样魅力。',
    tag: '技术前沿',
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20restoration%20cinematic%20scene%20with%20warm%20vintage%20tones%2C%20old%20movie%20projector%20aesthetic%2C%20golden%20and%20sepia%20colors%2C%20nostalgic%20atmosphere%2C%20film%20preservation&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '暑期亲子观影清单：全家一起看',
    desc: '精选适合全年龄段观看的优质影片，让亲子时光更加温馨有趣。',
    tag: '专题推荐',
    image: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20cinematic%20scene%20with%20warm%20cozy%20lighting%2C%20animation%20film%20poster%20style%2C%20soft%20amber%20and%20coral%20tones%2C%20heartwarming%20atmosphere%2C%20cheerful%20composition&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '韩剧为什么总能打动人心？',
    desc: '从剧本打磨到演员表演，韩剧制作体系的精良程度令人叹服，值得国产剧借鉴。',
    tag: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20cinematic%20scene%20with%20warm%20moody%20lighting%2C%20modern%20film%20poster%20style%2C%20amber%20and%20coral%20tones%2C%20emotional%20atmosphere%2C%20elegant%20composition&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '动作片迷必收：硬核打斗场面盘点',
    desc: '从港式功夫到好莱坞大片，那些让人血脉偾张的经典动作场面全收录。',
    tag: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20cinematic%20fight%20scene%20with%20dramatic%20warm%20lighting%2C%20film%20poster%20style%2C%20crimson%20and%20amber%20tones%2C%20intense%20atmosphere%2C%20dynamic%20composition&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    id: 7,
    title: '动漫迷福利：2024年最值得期待的番剧',
    desc: '国漫崛起与日漫经典齐头并进，全年最全追番指南来了。',
    tag: '追番指南',
    image: 'https://readdy.ai/api/search-image?query=Anime%20cinematic%20scene%20with%20warm%20vibrant%20colors%2C%20animation%20film%20poster%20style%2C%20golden%20and%20coral%20tones%2C%20dynamic%20atmosphere%2C%20colorful%20composition&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-600">最新影视动态、深度分析与观影指南</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CARD_ITEMS.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}